import { FormattedMessage, useIntl } from 'react-intl';
import { Displays, DisplaysValues } from '../type';
import styled from 'styled-components';

const LayoutFooter = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0.5vmin 2vmin;
`;

const FooterDescription = styled.div<{ $displayMode: DisplaysValues }>`
  flex: 1;
  text-align: center;
  white-space: pre-line;
  font-size: ${(props) =>
    props.$displayMode === Displays.LANDSCAPE ? '2.2vmin' : '3.1vmin'};
  text-shadow: 0 0.4vmin #000;
  -webkit-text-stroke: 0.03vmin #000;
`;

const FootLink = styled.a`
  color: #fff;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const Footer = ({ displayMode }: { displayMode: DisplaysValues }) => {
  const intl = useIntl();
  return (
    <LayoutFooter>
      <FooterDescription $displayMode={displayMode}>
        <FormattedMessage
          id="footer"
          values={{
            FanContentPolicy: (
              <>
                &laquo;
                <FootLink
                  href={intl.formatMessage({ id: 'fanContentPolicyLink' })}
                  target="_blank"
                >
                  <FormattedMessage id="fanContentPolicy" />
                </FootLink>
                &raquo;
              </>
            ),
          }}
        />
      </FooterDescription>
    </LayoutFooter>
  );
};
